import { graphql } from '@/generated/gql';

export const SOURCING_CASE_NEGOTIATION_SETTINGS_MUTATION = graphql(/* GraphQL */ `
  mutation SourcingCaseNegotiationSettingsMutation($id: UUID!, $data: TsrctSourcingCaseNegotiationSettingsInput!) {
    tesseract {
      sourcingCase(id: $id) {
        updateNegotiationSettings(data: $data) {
          id
          isNegotiationEnabled
          negotiationOptions {
            id
            initiatedBy
            negotiationObjective
            supplierInteractionMode
          }
          negotiationStrategy {
            id
            boundaryRules {
              base
              lower
              upper
            }
            useHistoricNegotiationData
            useHistoricTenderData
          }
        }
      }
    }
  }
`);
